import {
  CompanyProvisionResult,
  CompanyStandaloneResult,
} from '@app/domain/models/tpv/company.model';
import {
  CompanyProvisionResponseDto,
  CompanyStandaloneResponseDto,
} from '@app/data/dtos/tpv/company-provision.dto';

/** DTO de respuesta de provisión de Company -> entidad de dominio. */
export function mapCompanyProvisionResult(
  dto: CompanyProvisionResponseDto,
  fallbackIdCompany: string,
): CompanyProvisionResult {
  return {
    idCompany: dto.id_company ?? fallbackIdCompany,
    idUnit: dto.id_unit,
    status: dto.status,
  };
}

/** DTO de respuesta de provisión standalone -> entidad de dominio. */
export function mapCompanyStandaloneResult(
  dto: CompanyStandaloneResponseDto,
): CompanyStandaloneResult {
  return {
    idCompany: dto.id_company ?? '',
    externalIdCompany: dto.external_id_company,
    externalIdUnit: dto.external_id_unit,
    idGestor: dto.id_gestor,
    status: dto.status,
  };
}
